import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken, Injector } from '@angular/core';

import { ModalOptions } from './modal';
import { ModalRef } from './modal-ref';

export interface IModalWindowStackService {
    openModalWindow<T>(contentInjector: Injector, content: ComponentType<T>, options: ModalOptions): ModalRef<T>;
}

export const MODAL_WINDOW_STACK_TOKEN = new InjectionToken<IModalWindowStackService[]>('MODAL_WINDOW_STACK_TOKEN');
